<div class="w-full">
  <canvas
    baseChart
    [data]="chartData"
    [options]="chartOptions"
    [labels]="chartLabels"
    [chartType]="chartType"
    [legend]="chartLegend"
    [colors]="chartColors"
  ></canvas>
</div>
